export function timeZone(country) {
    const tab = {
	"MEX": "America/Mexico_City",
	"CAN": "America/Toronto",
	"USA": "America/New_York",
	"BRA": "America/Sao_Paulo",
	"ARG": "America/Argentina/Buenos_Aires",
	"GBR": "Europe/London",
	"NOR": "Europe/Oslo",
	"DEN": "Europe/Copenhagen",
	"SWE": "Europe/Stockholm",
	"NLD": "Europe/Amsterdam",
	"BEL": "Europe/Brussels",
	"DEU": "Europe/Berlin",
	"POL": "Europe/Warsaw",
	"FRA": "Europe/Paris",
	"CHE": "Europe/Zurich",
	"AUT": "Europe/Vienna",
	"ESP": "Europe/Madrid",
	"ITA": "Europe/Rome",
	"FIN": "Europe/Helsinki",
	"RUS": "Europe/Moscow",
	"TUR": "Europe/Istanbul",
	"IND": "Asia/Calcutta",
	"SIN": "Asia/Singapore",
	"CHN": "Asia/Hong_Kong",
	"KOR": "Asia/Seoul",
	"JPN": "Asia/Tokyo",
	"AUS": "Australia/Sydney"
    };
    return tab[country];
}

export function marketOpen(country) {
    const tab = {
	"MEX": 8.5,
	"CAN": 7,
	"USA": 9.5,
	"BRA": 10,
	"ARG": 11,
	"GBR": 8,
	"NOR": 9,
	"DEN": 9,
	"SWE": 8,
	"NLD": 9,
	"BEL": 9,
	"DEU": 9,
	"POL": 9,
	"FRA": 8,
	"CHE": 9,
	"AUT": 9,
	"ESP": 9,
	"ITA": 9,
	"FIN": 10,
	"RUS": 10,
	"TUR": 10,
	"IND": 9.25,
	"SIN": 9,
	"CHN": 9.5,
	"KOR": 9,
	"JPN": 9,
	"AUS": 10
    };
    return tab[country];
}

export function marketClosed(country) {
    const tab = {
	"MEX": 15,
	"CAN": 15.5,
	"USA": 16,
	"BRA": 16,
	"ARG": 17,
	"GBR": 16,
	"NOR": 16.5,
	"DEN": 17,
	"SWE": 17.5,
	"NLD": 17.67,
	"BEL": 17.5,
	"DEU": 17.5,
	"POL": 16.83,
	"FRA": 16.5,
	"CHE": 17.33,
	"AUT": 17.5,
	"ESP": 17.5,
	"ITA": 17.5,
	"FIN": 18.5,
	"RUS": 18.67,
	"TUR": 18,
	"IND": 15.5,
	"SIN": 17,
	"CHN": 16,
	"KOR": 15.5,
	"JPN": 15,
	"AUS": 16
    };
    return tab[country];
}

export const markets = {
	"USA.SP500": "US (S&P 500)",
	"USA.DJIA": "US (Dow Jones)",
	"USA.NASD_COMP": "US (NASDAQ)",
	"CAN.TSX": "Canada (TSX)",
	"MEX.IPC": "Mexico (IPC)",
	"BRA.BVP": "Brazil (BVP)",
	"ARG.MRV": "Argentina (MRV)",
	
	"DEU.DAX": "Germany (DAX)",
	"GBR.FTSE100": "UK (FTSE)",
	"FRA.CAC40": "France (CAC)", 
	"ESP.IBEX35": "Spain (IBEX)",
	"ITA.MIB": "Italy (MIB)", 
	"CHE.SMI": "Switzerland (SMI)",
	"POL.WIG20": "Poland (WIG)",
	"NLD.AEX": "Netherlands (AEX)",
	"BEL.BEL20": "Belgium (BEL)",
	"SWE.OMXS30": "Sweden (OMX)",
	"DEN.OMXC20": "Denmark (OMX)",
	"NOR.OSEBX": "Norway (OSEBX)",
	"FIN.HEX": "Finland (HEX)",
	"RUS.RTS": "Russia (RTS)",
	"TUR.XU100": "Turkey (XU)",
	
	"JPN.NIK225": "Japan (NIK)",
	"CHN.HSI": "China (HSI)",
	"CHN.SHC": "China (SHC)",
	"KOR.KOSPI": "S. Korea (KOSPI)",
	"IND.SNX": "India (SNX)",
	"SIN.STI": "Singapore (STI)",
	"AUS.AOR": "Australia (AOR)"
    };

export const days = {"1w": 7, "2w": 14, "3w": 21, "1m": 30, "2m": 60, "3m": 90,
		     "4m": 120, "5m": 150, "6m": 180, "1y": 360};
export const rdays = {"7":"1w", "14":"2w", "21":"3w", "30":"1m", "60":"2m", "90":"3m",
		      "120":"4m", "150":"5m", "180":"6m", "360": "1y"};

export const rmarkets = {};
export const countries = {};

for (var tic in markets) {
    rmarkets[markets[tic]] = tic;
    countries[markets[tic]] = tic.substring(0, 3);
}
